module.exports = __webpack_public_path__ + "img/fondo_test_1.def91ac9.svg";